<template>
  <v-skeleton-loader
    transition="transition"
    type="article"
    class="mb-5"
    :loading="loading"
  >
    <v-card
      class="mb-5 pa-5"
    >
      <p
        class="primary--text mb-4 subtitle-2 font-weight-bold text-uppercase text-center"
        data-cy="label_dados_do_vendedor"
      >
        Dados do vendedor
      </p>

      <p
        class="mb-5 grey--text text--darken-2"
        data-cy="label_texto_duvidas_atraves_dos_canais_de_atendimento"
      >
        Fale com {{ dadosDoVendedor.name }}.
      </p>

      <v-card-actions
        class="flex-column align-start pa-0"
      >
        <v-btn
          v-show="dadosDoVendedor.help_center"
          color="primary"
          outlined
          block
          class="mb-3"
          data-cy="bt_central_de_ajuda"
          tag="a"
          :href="dadosDoVendedor.help_center"
          target="_blank"
        >
          Central de ajuda
        </v-btn>

        <v-badge
          v-show="dadosDoVendedor.chat"
          bordered
          color="error"
          icon="mdi-bell"
          overlap
          style="width:100%"
        >
          <v-btn
            color="primary"
            outlined
            block
            class="ml-0 mb-6"
            data-cy="bt_falar_com_vendedor"
          >
            <v-img
              src="@/assets/img/icon-question.svg"
              contain
              height="18"
              max-width="18"
              class="mr-2"
            />
            Falar com o vendedor
          </v-btn>
        </v-badge>

        <a
          v-if="dadosDoVendedor.email"
          :href="`mailto:${ dadosDoVendedor.email }`"
          class="text-decoration-none mt-0 d-flex"
          data-cy="email_vendedor"
          target="_top"
        >
          <v-icon
            color="primary"
            class="mr-3"
          >
            mdi-email
          </v-icon>
          <span class="text-decoration-underline break-word">
            {{ dadosDoVendedor.email }}
          </span>
        </a>

        <a
          v-if="dadosDoVendedor.phone"
          :href="linkTelefone"
          class="text-decoration-none mt-5"
          data-cy="telefone_vendedor"
          target="_blank"
        >
          <v-icon
            color="primary"
            class="mr-3"
          >
            mdi-phone
          </v-icon>
          <span class="text-decoration-underline">
            {{ dadosDoVendedor.phone }}
          </span>
        </a>

        <a
          v-if="dadosDoVendedor.whatsapp"
          :href="linkWhatsapp"
          class="text-decoration-none mt-5"
          data-cy="whatsapp_vendedor"
          target="_blank"
        >
          <v-icon
            color="secondary"
            class="mr-3"
          >
            mdi-whatsapp
          </v-icon>
          <span class="text-decoration-underline">
            {{ dadosDoVendedor.whatsapp }}
          </span>
        </a>

        <BtnEnviarMensagem
          v-if="dadosTransacao.chat_enabled"
          :id-transacao="dadosTransacao.id"
          btn-block
          class="mt-5"
        />

        <v-badge
          v-if="notificacaoMensagem"
          avatar
          bordered
          color="red"
          offset-x="10"
          offset-y="-10"
        />
      </v-card-actions>
    </v-card>
  </v-skeleton-loader>
</template>

<script>
import { mapState } from 'vuex';
import BtnEnviarMensagem from '@/components/Chat/BtnEnviarMensagem.vue';

export default {
  name: 'CardDadosVendedor',

  components: {
    BtnEnviarMensagem,
  },

  props: {
    dadosDoVendedor: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
    notificacaoMensagem: {
      type: Boolean,
      required: true,
    },
  },

  computed: {
    ...mapState(['dadosTransacao']),

    linkTelefone() {
      let telefone = this.dadosDoVendedor.phone;
      telefone = telefone.match(/\d+/g).join([]);

      return `tel:${telefone}`;
    },

    linkWhatsapp() {
      let telefone = this.dadosDoVendedor.whatsapp;
      telefone = telefone.match(/\d+/g).join([]);

      return `https://api.whatsapp.com/send?l=pt_BR&phone=55${telefone}`;
    },
  },
};
</script>
